import React from "react";
import "./index.less";
import SidebarLogoV2 from "./SidebarLogoV2";
import SidebarMenuV2 from "./SidebarMenuV2";
import SidebarDownloadAppV2 from "../sidebar-v2/SidebarDownloadAppV2";
import SidebarTriggerV2 from "../sidebar-v2/SidebarTriggerV2";
import SidebarSettingV2 from "../sidebar-v2/SidebarSettingV2";
import SidebarFeatureFlagManager from "../sidebar-v2/SidebarFeatureFlagManager";
import { Button, Flex, Tag, Tooltip } from "@duxton-web/ui";
import {
  MenuBookUniversal,
  ShowFilled,
  UserGroupFilled,
} from "@duxton-web/icons";
import { MerchantSelector } from "@mex/mex-permissions-lib";
import useBackgroundDownload from "./useBackgroundDownload";
import { OBSERVER_KEY } from "../../constants";
import { isNotProd, isObserver } from "../../utils";

const createClasses = (classes) => {
  return Object.keys(classes)
    .map((classname) => (classes[classname] ? classname : null))
    .filter((classname) => classname)
    .join(" ");
};

const SidebarV2 = (props) => {
  useBackgroundDownload(props);

  const { collapsed, onCollapse } = props;
  const classNameLayout = createClasses({
    "troy-sidebar-layout": true,
    "troy-sidebar-v2": true,
    "enable-setting-icon": true,
    "troy-sidebar-expanded": !collapsed,
    "troy-sidebar-collapsed": collapsed,
  });
  const classNameFlagLogout = `troy-sidebar-bottom-${
    collapsed ? "collapsed" : "expanded"
  }`;

  const onClickStoryBook = () => {
    window.open("https://grab-transport.pages.myteksi.net/mex/mex-portal/");
  };

  const onClickObserver = () => {
    if (props.handleItemClick) props.handleItemClick({ key: OBSERVER_KEY });
  };

  const collapsedSiderbar = () => {
    return (
      <div className="menu-items-container-collapsed">
        <SidebarLogoV2 {...props} />
        {isObserver() && (
          <Flex vertical justify="center" align="center">
            <Tag
              icon={<ShowFilled />}
              color="success"
              style={{ margin: 0 }}
            ></Tag>
            <Tooltip title="Observer" placement="right">
              <Button
                style={{ marginTop: 8 }}
                icon={<UserGroupFilled />}
                onClick={onClickObserver}
                type="primary"
              ></Button>
            </Tooltip>
          </Flex>
        )}
        <div>
          <MerchantSelector collapsed />
        </div>
        <SidebarMenuV2 {...props} />
        <div className={"menu-items-bottom-wrapper "}>
          {isNotProd() && (
            <Button
              danger // set danger as not production sidebar
              shape="circle"
              style={{ marginBottom: 8 }}
              icon={<MenuBookUniversal style={{ fontSize: 20 }} />}
              onClick={onClickStoryBook}
            ></Button>
          )}
          {isNotProd() && <SidebarFeatureFlagManager {...props} />}
          <SidebarDownloadAppV2 {...props} />
          <SidebarSettingV2 {...props} />
          <SidebarTriggerV2 {...props} onClick={() => onCollapse(!collapsed)} />
        </div>
      </div>
    );
  };

  const expandedSiderbar = () => {
    return (
      <React.Fragment>
        <div className="menu-items-container">
          <div>
            <SidebarLogoV2 {...props} />
            {isObserver() && (
              <Flex vertical justify="center" align="center">
                <Tag
                  icon={<ShowFilled />}
                  color="success"
                  style={{ margin: 0 }}
                >
                  Observer Mode
                </Tag>
                <Button
                  style={{ marginTop: 8 }}
                  icon={<UserGroupFilled />}
                  onClick={onClickObserver}
                  type="primary"
                >
                  Observer
                </Button>
              </Flex>
            )}
            <MerchantSelector />
            <SidebarMenuV2 {...props} />
          </div>
          <div className={"menu-items-bottom-wrapper"}>
            {isNotProd() && (
              <Button
                danger // set danger as not production sidebar
                style={{ marginBottom: 8 }}
                icon={<MenuBookUniversal />}
                onClick={onClickStoryBook}
              >
                Storybook
              </Button>
            )}
            {isNotProd() && <SidebarFeatureFlagManager {...props} />}
            <SidebarDownloadAppV2 {...props} />
          </div>
        </div>
        <div className={classNameFlagLogout}>
          <div className={"troy-lang-logout-expanded"}>
            <SidebarSettingV2 {...props} />
            <SidebarTriggerV2
              {...props}
              onClick={() => onCollapse(!collapsed)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };
  return (
    <aside className={classNameLayout}>
      {collapsed ? collapsedSiderbar() : expandedSiderbar()}
    </aside>
  );
};

export default SidebarV2;
